import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useNavigate,
  useParams,
  useLocation,
  useSearchParams,
} from "react-router-dom";

import {
  FolderIcon,
  MXIcon,
  ClockIcon,
  CurriculumPlayIcon,
  CurriculumFileIcon,
} from "../../svg";
import {
  FormSubMissionButton,
  KingsterLogo,
  CourseFacebook,
  CourseLinkedIn,
  CourseTwitter,
  GetInTouch,
  Webinar, FreeWebinar,
  CourseButtonArrow,
  Duration,
  Live,
  Calendar,
  Recorded,
} from "../../svg";
import FaqList from "../../component/FaqList";
import FooterComponent from "../../component/FooterComponent";
import Toastify from "../helper/Toastify";
import api from "../helper/Api";
import { getProfile } from "../redux/userSlice";
import { viewSingleWebinar } from "../redux/courseSlice";
import { useFormik } from "formik";
import * as yup from "yup";
import enrollCourseImage from "../../image/enrollCourse.jpg";
import ReCAPTCHA from "react-google-recaptcha";
import { CircularProgress } from "@mui/material";
import VideoModal from "../../component/VideoModal";
import { ChevronLeft, ChevronRight } from "lucide-react";

const carouselData = [
  {
    id: 1,
    title: "Brick and Mortar Owners",
    description: "Launch your business venture and make it successful.",
    image:
      "https://www.shutterstock.com/image-photo/book-open-pages-close-up-600nw-2562942291.jpg",
  },
  {
    id: 2,
    title: "Offline Store Owners",
    description: "Think concretely about digitizing your business.",
    image:
      "https://www.shutterstock.com/image-photo/book-open-pages-close-up-600nw-2562942291.jpg",
  },
  {
    id: 3,
    title: "Online Entrepreneurs",
    description: "Scale your online business with the right tools.",
    image:
      "https://www.shutterstock.com/image-photo/book-open-pages-close-up-600nw-2562942291.jpg",
  },
  {
    id: 4,
    title: "Online Entrepreneurs",
    description: "Scale your online business with the right tools.",
    image:
      "https://www.shutterstock.com/image-photo/book-open-pages-close-up-600nw-2562942291.jpg",
  },
];

const WebinarDetailsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const userProfile = useSelector((state) => state.user);
  const [webinar, setWebinar] = useState(null);
  const [playModal, setPlayModal] = useState(false);

  // const faqSectionRef = useRef(null);
  const registerFormRef = useRef(null);

  // UTM Tracking States
  const [source, setSource] = useState("Website");
  const [affiliateId, setAffiliateId] = useState(null);
  const [affiliateSource, setAffiliateSource] = useState(null);

  // Add state for captcha verification
  const [captchaVerified, setCaptchaVerified] = useState(true);
  const [captchaToken, setCaptchaToken] = useState("");
  const [loading, setLoading] = useState(false);

  // State for handling logged-in user submission
  const [isSubmittingWithUserData, setIsSubmittingWithUserData] = useState(false);
  const [showUserDataButton, setShowUserDataButton] = useState(false);

  // Add reCAPTCHA site key
  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const getUserProfile = userProfile?.user?.courses;
  const purchasedCourseId = getUserProfile?.find((item) => item === id);

  // Memoized URL search parameters to prevent unnecessary re-parsing
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  // Handle captcha change
  const handleCaptchaChange = (token) => {
    setCaptchaVerified(!!token);
    setCaptchaToken(token);
  };

  const useLazyBackground = (imageUrl) => {
    const [shouldLoad, setShouldLoad] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
      if (!imageUrl || shouldLoad) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setShouldLoad(true);
            observer.unobserve(entry.target);
          }
        },
        { rootMargin: "100px" }
      );

      if (ref.current) {
        observer.observe(ref.current);
      }

      return () => {
        if (ref.current) observer.unobserve(ref.current);
      };
    }, [imageUrl, shouldLoad]);

    return { ref, shouldLoad };
  };

  // UTM Parameter handling
  useEffect(() => {
    const utmSource = queryParams.get("utm_source")?.toLowerCase();
    const utmAffiliate = queryParams.get("utm_affiliate");
    const utmAffiliateSource = queryParams.get("utm_affiliate_source");

    if (utmSource === "affiliate" && utmAffiliate) {
      setSource("Affiliate");
      setAffiliateId(utmAffiliate);
      setAffiliateSource(utmAffiliateSource || "Unknown");
    } else if (utmSource) {
      setSource(utmSource.charAt(0).toUpperCase() + utmSource.slice(1));
    } else {
      setSource("Website");
    }
  }, [queryParams]);

  useEffect(() => {
    const getWebinars = async () => {
      try {
        const data = await dispatch(viewSingleWebinar(id)).unwrap();
        if (data) {
          setWebinar(data?.webinarDetails);
        }
      } catch (err) {
        console.log("fetching failed");
      }
    };
    getWebinars();
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  // Check if user is logged in and set showUserDataButton
  useEffect(() => {
    const isLoggedIn = userProfile?.user && Object.keys(userProfile.user).length > 0;
    setShowUserDataButton(isLoggedIn);
  }, [userProfile]);

  // this is msme data
  const msmSupportData = [
    {
      title: `Mission-Driven Learning `,
      description:
        "We are on a mission to empower 10,000+ Indian entrepreneurs to build profitable, scalable, and sustainable e-commerce brands that create real economic impact.",
    },
    {
      title: "Vision for Long-Term Growth",
      description:
        "Our vision is to create India's most trusted ecosystem for entrepreneurial learning and brand building, where education transforms into lasting business success.",
    },
    {
      title: " Education That Delivers Results",
      description:
        "We don’t teach theory, we focus on actionable strategies that you can implement immediately to grow revenue, build brand trust, and achieve consistency.",
    },
    {
      title: " Entrepreneur-First Approach",
      description:
        "MSMEs reported increased online sales, better customer acquisition and retention, and greater operational efficiency after completing the program.",
    },
    {
      title: "Sustainable Business Building",
      description: "We help you build systems, not shortcuts, creating long-term, automated revenue engines through strategy, content, and customer experience."
    },
    {
      title: "Data-Driven Growth Frameworks",
      description: "Our methods combine marketinsights, audience analytics, and brand positioning to help you make smarter, faster, and more confident business decisions."
    },
    {
      title: "Conversion-Optimized Brand Strategy",
      description: "From website UX to storytelling, every aspect of your brand is refined to increase conversions, repeat purchases, and lifetime customer value."
    },
    {
      title: "Community & Collaboration",
      description: "Join a thriving network of e-commerce founders, mentors, and investors who share insights, partnerships, and opportunities for collective growth."
    },
    {
      title: " Mentorship That Lasts",
      description: "Our commitment doesn’t end after the webinar, we provide ongoing mentorship, support, and growth programs to guide your journey from startup to brand."
    }
  ];

  const [current, setCurrent] = useState(0);

  const scrollToRegisterForm = () => {
    if (registerFormRef.current) {
      registerFormRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // Add this with your other state declarations
  const [expandedModule, setExpandedModule] = useState(null);

  // Add this function to handle accordion toggle
  const handleModuleToggle = (index) => {
    setExpandedModule(expandedModule === index ? null : index);
  };

  const [useDummyVideo, setUseDummyVideo] = useState(false);

  const handleTrailerPlay = () => {
    if (webinar?.trailer && webinar?.trailer[0]?.url) {
      setPlayModal(true);
      setUseDummyVideo(false);
    } else {
      setPlayModal(true);
      setUseDummyVideo(true);
    }
  };

  // show 3 items per slide
  const itemsPerSlide = 2;
  const totalSlides = Math.ceil(carouselData.length / itemsPerSlide);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev === totalSlides - 1 ? 0 : prev + 1));
  };

  const calculateDuration = (startTime, endTime) => {
    if (!startTime || !endTime) {
      return { value: "2", unit: "hours" }; // Default fallback
    }

    try {
      const [startHours, startMinutes] = startTime.split(":").map(Number);
      const [endHours, endMinutes] = endTime.split(":").map(Number);

      const startDate = new Date(2000, 0, 1, startHours, startMinutes);
      const endDate = new Date(2000, 0, 1, endHours, endMinutes);

      if (endDate < startDate) {
        endDate.setDate(endDate.getDate() + 1);
      }

      const diffMinutes = (endDate - startDate) / (1000 * 60);
      const hours = Math.floor(diffMinutes / 60);
      const minutes = diffMinutes % 60;

      if (hours > 0) {
        return {
          value: hours.toString(),
          unit: hours === 1 ? "hour" : "hours",
        };
      } else {
        return {
          value: minutes.toString(),
          unit: minutes === 1 ? "minute" : "minutes",
        };
      }
    } catch (error) {
      console.error("Error calculating duration:", error);
      return { value: "2", unit: "hours" };
    }
  };

  // Dynamic key program highlights icons
  const keyProgramIcons = [
    <svg key="curriculum" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-14 h-14 text-[#1D83F8]">
      <path strokeLinecap="round" strokeLinejoin="round" d="M7 5h10M7 9h10M7 13h7m-9 6h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>,
    <svg key="industry" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-14 h-14 text-[#1D83F8]">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 8a4 4 0 100 8 4 4 0 000-8zm0-6v2m0 16v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>,
    <svg key="online" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-14 h-14 text-[#1D83F8]">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5h18v12H3V5zm2 14h14" />
    </svg>,
    <svg key="support" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-14 h-14 text-[#1D83F8]">
      <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>,
    <svg key="certificate" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-14 h-14 text-[#1D83F8]">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    </svg>,
    <svg key="community" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-14 h-14 text-[#1D83F8]">
      <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
  ];

  // Static data for webinar (since some data might not be available)
  const staticWebinarData = {
    bestSuitFor: webinar?.bestSuitFor || [
      "Entrepreneurs",
      "Business Owners",
      "Students",
      "Working Professionals",
      "Startup Founders",
    ],
    duration: calculateDuration(
      webinar?.webinarStartTime,
      webinar?.webinarEndTime
    ),
    keyTakeAways: webinar?.keyTakeAways || [
      "Live interactive session",
      "Industry expert insights",
      "Q&A opportunity",
      "Practical knowledge",
      "Networking opportunity",
    ],
  };

  // Enquiry Form Schema
  const enquirySchema = yup.object().shape({
    email: yup
      .string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter valid email"
      )
      .required("Please enter valid email"),
    name: yup.string().required("Name is required"),
    lastName: yup.string().notRequired(),
    primaryNumber: yup.string().required("Number is required"),
    message: yup.string().required("Description is required"),
    address: yup.string().required("Address is required"),
    acceptedTerms: yup
      .boolean()
      .oneOf([true], "Please accept Terms of Use and Privacy Policy"),
  });

  // Enquiry Form with UTM Tracking
  const {
    errors: enquiryErrors,
    values: enquiryValues,
    handleChange: handleEnquiryChange,
    handleSubmit: handleEnquirySubmit,
    touched: enquiryTouched,
    resetForm: resetEnquiryForm,
    setValues: setEnquiryValues,
  } = useFormik({
    initialValues: {
      name: "",
      lastName: "",
      email: "",
      primaryNumber: "",
      message: "",
      address: "",
      source: source,
      affiliateId: affiliateId || "",
      affiliateSource: affiliateSource || "",
      webinarId: `${id}`, // Change from courseId to webinarId
      leadType: "WEBINAR", // Add leadType
      acceptedTerms: false,
    },
    validationSchema: enquirySchema,
    onSubmit: (values) => {
      handleEnquirySubmission(values);
      resetEnquiryForm();
    },
  });

  const handleEnquirySubmission = async (values) => {
    try {
      if (!captchaVerified) {
        Toastify.error("Please complete the CAPTCHA verification");
        return;
      }

      if (!values.acceptedTerms) {
        Toastify.error("Please accept Terms of Use and Privacy Policy");
        return;
      }

      setLoading(true);
      const payload = {
        ...values,
        source,
        captchaToken,
        ...(source === "Affiliate" && { affiliateId, affiliateSource }),
        leadType: "WEBINAR", // Ensure leadType is set
        webinarId: id, // Use webinarId
      };

      const { data, status } = await api.addLead(payload);

      if (status === 200) {
        Toastify.success("Enquiry submitted successfully!");
        if (window.grecaptcha) {
          window.grecaptcha.reset();
        }
        setCaptchaVerified(false);
        setCaptchaToken("");
        // Reset the user data button state
        setIsSubmittingWithUserData(false);
      } else {
        Toastify.error(data.message);
      }
    } catch (error) {
      console.error("Error submitting enquiry", error);
      Toastify.error(error?.response?.data?.message || "Internal server error");
    } finally {
      setLoading(false);
    }
  };

  // Function to handle submission with logged-in user data
  const handleSubmitWithUserData = async () => {
    try {
      setIsSubmittingWithUserData(true);
      
      // Get user data from Redux store
      const userData = userProfile?.user;
      
      if (!userData) {
        Toastify.error("User data not found. Please log in again.");
        return;
      }

      // Split full name into first and last name if needed
      const fullName = userData.name || userData.fullName || "";
      const nameParts = fullName.split(" ");
      const firstName = nameParts[0] || "";
      const lastName = nameParts.slice(1).join(" ") || "";

      // Prepare payload with user data
      const payload = {
        name: firstName,
        lastName: lastName,
        email: userData.email || "",
        primaryNumber: userData.phone || userData.mobile || "",
        message: `Registered for webinar: ${webinar?.title || "Webinar"} by logged-in user: ${fullName}`,
        address: userData.address || userData.city || "Not provided",
        source: source,
        affiliateId: affiliateId || "",
        affiliateSource: affiliateSource || "",
        webinarId: id,
        leadType: "WEBINAR",
        captchaToken: captchaToken,
      };

      // Validate required fields
      if (!payload.email || !payload.name || !payload.primaryNumber) {
        Toastify.error("Please ensure your profile has email, name, and phone number");
        setIsSubmittingWithUserData(false);
        return;
      }

      // Check captcha if needed (optional for logged-in users)
      if (!captchaVerified) {
        Toastify.error("Please complete the CAPTCHA verification");
        setIsSubmittingWithUserData(false);
        return;
      }

      if (!enquiryValues.acceptedTerms) {
        Toastify.error("Please accept Terms of Use and Privacy Policy");
        setIsSubmittingWithUserData(false);
        return;
      }

      setLoading(true);
      const { data, status } = await api.addLead(payload);

      if (status === 200) {
        Toastify.success("Registration successful! You're registered for the webinar.");
        if (window.grecaptcha) {
          window.grecaptcha.reset();
        }
        setCaptchaVerified(false);
        setCaptchaToken("");
        setIsSubmittingWithUserData(false);
      } else {
        Toastify.error(data.message || "Registration failed");
        setIsSubmittingWithUserData(false);
      }
    } catch (error) {
      console.error("Error submitting user data", error);
      Toastify.error(error?.response?.data?.message || "Registration failed. Please try again.");
      setIsSubmittingWithUserData(false);
    } finally {
      setLoading(false);
    }
  };

  const formatWebinarDateTime = (date, time) => {
    if (!date || !time) return "Date to be announced";

    const combinedDate = new Date(`${date?.split("T")[0]}T${time}`);
    const formattedDate = combinedDate.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    const formattedTime = combinedDate.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return `${formattedDate} @ ${formattedTime}`;
  };

  const faqSectionRef = useRef(null);

  const scrollToFaq = () => {
    if (faqSectionRef.current) {
      faqSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const mainImageUrl = webinar?.webinarBanner?.[0] || webinar?.thumbnail?.[0];
  const { ref: mainImageRef, shouldLoad: shouldLoadMainImage } = useLazyBackground(mainImageUrl);

  return (
    <div>
      <VideoModal
        thumbnail={useDummyVideo ? "https://via.placeholder.com/800x450/1D83F8/FFFFFF?text=Sample+Webinar+Trailer" : webinar?.thumbnail?.[0]}
        title={webinar?.title}
        open={playModal}
        closeModal={() => {
          setPlayModal(false);
          setUseDummyVideo(false);
        }}
        video={useDummyVideo ? "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" : webinar?.trailer?.[0]?.url}
      />
      <div className="flex flex-col gap-5 font-figtree text-gray-800">
        {/* Breadcrumbs */}
        <div className="flex justify-center w-full px-4 text-sm md:text-lg font-medium leading-6 md:leading-7 tracking-tighter text-left">
          Home / Webinars /&nbsp;
          <span className="text-blue-500">
            {webinar?.title?.split(" ").slice(0, 3).join(" ") + "..."}
          </span>
        </div>

        {/* iwirwiri */}
        <div className="px-4 sm:px-6 lg:px-16 pt-0 max-w-[1500px]  w-full mx-auto">
          <div
            ref={mainImageRef}
            className="relative flex justify-end items-end rounded-2xl w-full aspect-[0.6] sm:aspect-[1.4] lg:aspect-[1.9] h-[707px]"
            style={{
              backgroundImage: shouldLoadMainImage ? `
      linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.9)),
      url(${mainImageUrl})
    ` : 'none',
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* Webinar Badge */}
            <div className="absolute top-[10px] right-3 sm:right-5 flex items-center gap-3 sm:gap-5 pt-4">
              <div className="lg:w-[184px] w-[100px] p-2 lg:h-[62px] h-[40px] bg-[#76CD4E] text-white flex items-center justify-center gap-2 rounded-xl lg:text-lg text-[10px] font-bold opacity-100">
                {/* White Calendar Icon */}
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="white"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17Z" />
                </svg>
                Free Webinar
              </div>
            </div>

            <div className="w-full text-white p-4 sm:p-6 lg:p-8">
              <div className="flex flex-col lg:flex-row items-start lg:items-end w-full gap-6">
                {/* Left Content */}
                <div className="w-full lg:w-[80%] lg:pl-4">
                  <div className="font-[Figtree] font-medium text-[20px] sm:text-[50px] lg:text-[45px] leading-[100%] tracking-[-0.06em] capitalize">
                    {webinar?.title}
                  </div>

                  {/* Webinar Date and Time Display - Simple Version */}
                  <div className="flex items-center gap-2 pt-3 sm:pt-4 font-bold text-[24px] leading-[150%] tracking-[-0.04em]">
                    <Calendar />
                    <span className="font-[Figtree]">
                      {webinar?.webinarDate ? (
                        <>
                          {new Date(webinar.webinarDate).toLocaleDateString("en-US", {
                            day: "numeric",
                            month: "short",
                            year: "numeric"
                          })}
                          {" , "}
                          {webinar?.webinarStartTime ? (
                            new Date(`2000-01-01T${webinar.webinarStartTime}`).toLocaleTimeString("en-US", {
                              hour: "numeric",
                              minute: "2-digit",
                              hour12: true
                            })
                          ) : "Time TBA"}
                        </>
                      ) : (
                        "Date to be announced"
                      )}
                    </span>
                  </div>

                  <div className="flex items-center gap-2 pt-3 sm:pt-4 font-bold text-[24px] leading-[150%] tracking-[-0.04em]">
                    <img
                      className="w-[43px] h-[43px] opacity-100"
                      src="/assets/icons/duration.svg"
                      alt=""
                    />
                    <span className="font-[Figtree]">
                      {staticWebinarData.duration.value}{" "}
                      {staticWebinarData.duration.unit} Duration
                    </span>
                  </div>

                  <p className="flex items-center gap-2 font-[Figtree] mt-6">
                    <span className="relative flex h-3 w-3">
                      <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping"></span>
                      <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
                    </span>
                    <span className="font-bold text-lg">Live Online via Zoom</span>
                  </p>

                  <div className="mt-3 w-[80%] pt-4 sm:mt-4 font-[Figtree] font-medium lg:text-[20px] text-[15px] leading-[125%] tracking-[-0.04em] capitalize">
                    {webinar?.subtitle || "Join Kingster Education's flagship webinar to learn valuable insights and practical knowledge from industry experts."}
                  </div>

                  {/* Buttons */}
                  <div className="flex flex-wrap items-center gap-3 sm:gap-4 pt-3 sm:pt-4">
                    <button
                      type="submit"
                      className="flex font-[Figtree] items-center font-bold
      justify-center gap-1 px-3 mt-3 py-2 text-base text-white
      bg-blue-500 rounded-full outline outline-2 outline-white"
                      onClick={scrollToRegisterForm}  // Add this onClick handler
                    >
                      <img
                        className="lg:w-[50px] lg:h-[50px] sm:w-8 sm:h-8"
                        src="/assets/icons/enroll.svg"
                        alt=""
                      />
                      Join Free Webinar
                    </button>

                    {/* Play button and Watch trailer text in same line */}
                    <div className="flex items-center gap-2">
                      <a
                        onClick={handleTrailerPlay}
                        className="flex items-center justify-center cursor-pointer"
                      >
                        <img
                          className="w-10 h-10 sm:w-12 sm:h-12"
                          src="/assets/icons/play.svg"
                          alt=""
                        />
                      </a>
                      <a
                        className="flex items-center justify-center underline cursor-pointer text-sm sm:text-base whitespace-nowrap"
                        onClick={handleTrailerPlay}
                      >
                        Watch trailer
                      </a>
                    </div>
                  </div>
                </div>

                {/* Right Tags */}
                <div className="w-full lg:w-[50%] flex flex-wrap gap-2 sm:gap-3">
                  {staticWebinarData.bestSuitFor?.map((item, index) => (
                    <div
                      key={index}
                      className="w-[100px] sm:w-[90px] md:w-[140px] h-[40px] sm:h-[45px] md:h-[52px] 
                      flex items-center justify-center rounded-[100px] border border-gray-300 p-1 sm:p-2
                       font-[Figtree] font-semibold text-xs sm:text-sm md:text-[14px] leading-[140%] sm:leading-[150%]
                        tracking-[-0.02em] sm:tracking-[-0.03em] md:tracking-[-0.04em] capitalize bg-white text-gray-800 text-center"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Webinar Details */}
        <div className="flex flex-col items-center px-4 sm:px-6 lg:px-10 max-w-[1400px] w-full mx-auto mt-12">
          <div className="flex flex-col lg:flex-row justify-between items-start w-full gap-6 lg:gap-4">
            {/* Left Section - Webinar Details */}
            <div className="w-full lg:w-7/12">
              <div className="pb-4 sm:pb-6 md:pb-10 w-full text-left 
               text-blue-500 font-[Figtree] font-bold text-3xl sm:text-4xl
                md:text-5xl lg:text-[64px] leading-snug sm:leading-tight md:leading-[100%] 
                tracking-[-0.02em] sm:tracking-[-0.03em] md:tracking-[-0.04em]">
                Free Webinar Details
              </div>

              {/* Intro Section */}
              <div className="bg-[#F6F9FE] p-5 rounded-2xl mb-6">
                <div
                  className="font-[Figtree] font-[400] text-[21px] leading-[150%] tracking-[-0.04em] !text-[#59595A] [&_*]:!text-[#59595A] [&_*]:font-normal"
                  dangerouslySetInnerHTML={{
                    __html:
                      webinar?.webinarOverview ||
                      webinar?.description ||
                      "Join our exclusive webinar to gain valuable insights and practical knowledge from industry experts.",
                  }}
                />
              </div>
            </div>

            {/* Right Section - Enquiry Form or User Data Button */}
            <div
              ref={registerFormRef}
              className="w-full lg:w-5/12 lg:ml-6 p-4 mt-4 sm:p-6 bg-white rounded-2xl shadow-[2px_1px_44px_4px_rgba(0,0,0,0.09)]"
            >
              <h1 className="font-[Figtree] font-semibold text-[28px] leading-[150%] tracking-[-0.04em] text-black mb-6 border-b-2 border-[#1D83F8] pb-3 -mx-4 sm:-mx-6 px-4 sm:px-6">
                Register for Free Webinar
              </h1>

              {showUserDataButton && !isSubmittingWithUserData ? (
                // Show Continue with User Data button for logged-in users
                <div className="flex flex-col items-center gap-6 py-8">
                  <div className="text-center mb-4">
                    <p className="text-gray-700 mb-2">You're already logged in as:</p>
                    <p className="font-semibold text-lg text-gray-900">
                      {userProfile?.user?.name || userProfile?.user?.fullName || "User"}
                    </p>
                    <p className="text-gray-600">{userProfile?.user?.email}</p>
                  </div>
                  <label className="flex items-center gap-2 text-gray-600 font-medium w-full max-w-[300px]">
                    <input
                      type="checkbox"
                      name="acceptedTerms"
                      checked={enquiryValues.acceptedTerms}
                      onChange={handleEnquiryChange}
                      className="w-5 h-5 sm:w-6 sm:h-6 bg-gray-500 font-[Figtree]"
                    />
                    I agree with Terms of Use and Privacy Policy
                  </label>
                  {enquiryErrors.acceptedTerms && enquiryTouched.acceptedTerms && (
                    <p className="text-red-500 text-xs mt-1 text-center">
                      {enquiryErrors.acceptedTerms}
                    </p>
                  )}
                  <button
                    type="button"
                    onClick={handleSubmitWithUserData}
                    className="flex items-center justify-center gap-3 bg-[#1D83F8] 
                    hover:bg-blue-700 text-white px-6 py-4 rounded-full w-full max-w-[300px] h-16
                     border border-transparent transition text-sm font-bold"
                    disabled={loading || !enquiryValues.acceptedTerms}
                  >
                    {loading ? (
                      <CircularProgress size={30} color="white" thickness={5} />
                    ) : (
                      <>
                        <img src="/assets/icons/enroll.svg" alt="" />
                        Continue with My Data
                      </>
                    )}
                  </button>
                  <p className="text-sm text-gray-500 text-center mt-2">
                    We'll use your registered profile information to register you for this webinar
                  </p>
                </div>
              ) : (
                // Show registration form for non-logged-in users or when submitting
                <form
                  className="flex flex-col gap-6"
                  onSubmit={handleEnquirySubmit}
                >
                  {/* First & Last Name */}
                  <div className="flex flex-col sm:flex-row gap-5 p-3">
                    <div className="flex-1 flex flex-col">
                      <label
                        htmlFor="firstName"
                        className="text-gray-800 font-medium mb-1"
                      >
                        First Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        value={enquiryValues.name}
                        name="name"
                        onChange={handleEnquiryChange}
                        placeholder=""
                        className="w-full h-12 px-4 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                      />
                      {enquiryErrors.name && enquiryTouched.name && (
                        <p className="text-red-500 text-xs mt-1">
                          {enquiryErrors.name}
                        </p>
                      )}
                    </div>

                    <div className="flex-1 flex flex-col">
                      <label
                        htmlFor="lastName"
                        className="text-gray-800 font-medium mb-1"
                      >
                        Last Name
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        value={enquiryValues.lastName}
                        name="lastName"
                        onChange={handleEnquiryChange}
                        placeholder=""
                        className="w-full h-12 px-4 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                      />
                      {enquiryErrors.lastName && enquiryTouched.lastName && (
                        <p className="text-red-500 text-xs mt-1">
                          {enquiryErrors.lastName}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Email & Phone */}
                  <div className="flex flex-col sm:flex-row gap-5 p-3">
                    <div className="flex-1 flex flex-col">
                      <label
                        htmlFor="email"
                        className="text-gray-800 font-medium mb-1"
                      >
                        Email <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        value={enquiryValues.email}
                        name="email"
                        onChange={handleEnquiryChange}
                        placeholder=""
                        className="w-full h-12 px-4 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                      />
                      {enquiryErrors.email && enquiryTouched.email && (
                        <p className="text-red-500 text-xs mt-1">
                          {enquiryErrors.email}
                        </p>
                      )}
                    </div>

                    <div className="flex-1 flex flex-col">
                      <label
                        htmlFor="phone"
                        className="text-gray-800 font-medium mb-1"
                      >
                        Phone <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="phone"
                        value={enquiryValues.primaryNumber}
                        name="primaryNumber"
                        onChange={handleEnquiryChange}
                        placeholder=""
                        className="w-full h-12 px-4 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                      />
                      {enquiryErrors.primaryNumber &&
                        enquiryTouched.primaryNumber && (
                          <p className="text-red-500 text-xs mt-1">
                            {enquiryErrors.primaryNumber}
                          </p>
                        )}
                    </div>
                  </div>

                  {/* Address */}
                  <div className="flex flex-col p-3">
                    <label
                      htmlFor="address"
                      className="text-gray-800 font-medium mb-1"
                    >
                      Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="address"
                      value={enquiryValues.address}
                      name="address"
                      onChange={handleEnquiryChange}
                      placeholder=""
                      className="w-full h-12 px-4 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                    />
                    {enquiryErrors.address && enquiryTouched.address && (
                      <p className="text-red-500 text-xs mt-1">
                        {enquiryErrors.address}
                      </p>
                    )}
                  </div>

                  {/* Message */}
                  <div className="flex flex-col p-3">
                    <label
                      htmlFor="message"
                      className="text-gray-800 font-medium mb-1"
                    >
                      Message <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      id="message"
                      value={enquiryValues.message}
                      name="message"
                      onChange={handleEnquiryChange}
                      placeholder=""
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 h-24"
                    ></textarea>
                    {enquiryErrors.message && enquiryTouched.message && (
                      <p className="text-red-500 text-xs mt-1">
                        {enquiryErrors.message}
                      </p>
                    )}
                  </div>

                  {/* Terms & Submit */}
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 px-3">
                    <label className="flex items-center gap-2 text-gray-600 font-medium">
                      <input
                        type="checkbox"
                        name="acceptedTerms"
                        checked={enquiryValues.acceptedTerms}
                        onChange={handleEnquiryChange}
                        className="w-5 h-5 sm:w-6 sm:h-6 bg-gray-500 font-[Figtree]"
                      />
                      I agree with Terms of Use and Privacy Policy
                    </label>
                    {enquiryErrors.acceptedTerms && enquiryTouched.acceptedTerms && (
                      <p className="text-red-500 text-xs mt-1 px-3">
                        {enquiryErrors.acceptedTerms}
                      </p>
                    )}
                  </div>

                  {/* Add reCAPTCHA here */}
                  <div className="px-3">
                    <ReCAPTCHA
                      sitekey={
                        RECAPTCHA_SITE_KEY ||
                        "6LeKca0rAAAAAEloRJKpYzxi2UB-wOPVXl5fYGKz"
                      }
                      onChange={handleCaptchaChange}
                    />
                  </div>

                  <button
                    type="submit"
                    className="mb-12 m-auto flex items-center justify-center gap-3 bg-[#1D83F8] 
                    hover:bg-blue-700 text-white px-3 py-4 rounded-full w-auto max-w-[300px] h-16
                     border border-transparent transition text-sm font-bold "
                    disabled={loading || !captchaVerified || !enquiryValues.acceptedTerms}
                  >
                    {loading ? (
                      <CircularProgress size={30} color="white" thickness={5} />
                    ) : (
                      <>
                        <img src="/assets/icons/enroll.svg" alt="" />
                        Register for Free Webinar
                      </>
                    )}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>

        {/* Dynamic Key Program Highlights */}
        <div className="flex flex-col items-center px-4 sm:px-6 lg:px-10 py-5 max-w-[1400px] w-full mx-auto my-8">
          <div className="font-[Figtree] mb-12 font-bold text-[#1D83F8] text-[32px] sm:text-[48px] lg:text-[64px] leading-[100%] tracking-[-0.04em] text-center">
            Benefits of Webinar
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 py-5">
            {webinar?.KeyProgramHighlights?.map((highlight, index) => (
              <div
                key={index}
                className="bg-[#F9FAFB] rounded-2xl p-6 flex flex-col items-start text-left gap-3 border border-transparent hover:border-2 hover:border-[#1D83F8] transition-all duration-300 min-h-[358px]"
              >
                {highlight?.img?.[0] && (
                  <div className="w-14 h-14 flex items-center justify-center">
                    <img
                      src={highlight.img[0]}
                      alt={highlight?.title || `Benefit ${index + 1}`}
                      className="w-full h-full object-contain"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                )}

                {!highlight?.img?.[0] && (keyProgramIcons[index] || keyProgramIcons[0])}

                <h3 className="font-[Figtree] font-bold text-[22px] sm:text-[26px] leading-[120%] tracking-[-0.02em] text-gray-900">
                  {highlight.title || `Benefit ${index + 1}`}
                </h3>
                <p className="font-[Figtree] font-medium text-[15px] leading-[150%] tracking-[-0.02em] text-[#023054]">
                  {highlight.description || highlight.subTitle || "Learn valuable insights and practical knowledge from industry experts."}
                </p>
              </div>
            ))}

            {(!webinar?.KeyProgramHighlights || webinar.KeyProgramHighlights.length === 0) && (
              <>
                <div className="bg-[#F9FAFB] rounded-2xl p-6 flex flex-col items-start text-left gap-3 border border-transparent hover:border-2 hover:border-[#1D83F8] transition-all duration-300 min-h-[358px]">
                  <div className="w-14 h-14 flex items-center justify-center">
                    <img
                      src="/assets/icons/expert-sessions.svg" 
                      alt="Expert-Led Sessions"
                      className="w-full h-full object-contain"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = keyProgramIcons[0];
                      }}
                    />
                  </div>
                  <h3 className="font-[Figtree] font-bold text-[22px] sm:text-[26px] leading-[120%] tracking-[-0.02em] text-gray-900">
                    Expert-Led Sessions
                  </h3>
                  <p className="font-[Figtree] font-medium text-[15px] leading-[150%] tracking-[-0.02em] text-[#023054]">
                    Learn from industry experts with years of practical experience in their fields.
                  </p>
                </div>

                <div className="bg-[#F9FAFB] rounded-2xl p-6 flex flex-col items-start text-left gap-3 border border-transparent hover:border-2 hover:border-[#1D83F8] transition-all duration-300 min-h-[358px]">
                  <div className="w-14 h-14 flex items-center justify-center">
                    <img
                      src="/assets/icons/practical-insights.svg"
                      alt="Practical Insights"
                      className="w-full h-full object-contain"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = keyProgramIcons[1];
                      }}
                    />
                  </div>
                  <h3 className="font-[Figtree] font-bold text-[22px] sm:text-[26px] leading-[120%] tracking-[-0.02em] text-gray-900">
                    Practical Insights
                  </h3>
                  <p className="font-[Figtree] font-medium text-[15px] leading-[150%] tracking-[-0.02em] text-[#023054]">
                    Gain actionable knowledge that you can immediately apply to your business or career.
                  </p>
                </div>

                <div className="bg-[#F9FAFB] rounded-2xl p-6 flex flex-col items-start text-left gap-3 border border-transparent hover:border-2 hover:border-[#1D83F8] transition-all duration-300 min-h-[358px]">
                  <div className="w-14 h-14 flex items-center justify-center">
                    <img
                      src="/assets/icons/interactive-learning.svg"
                      alt="Interactive Learning"
                      className="w-full h-full object-contain"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = keyProgramIcons[2];
                      }}
                    />
                  </div>
                  <h3 className="font-[Figtree] font-bold text-[22px] sm:text-[26px] leading-[120%] tracking-[-0.02em] text-gray-900">
                    Interactive Learning
                  </h3>
                  <p className="font-[Figtree] font-medium text-[15px] leading-[150%] tracking-[-0.02em] text-[#023054]">
                    Participate in live Q&A sessions and interactive discussions with speakers and peers.
                  </p>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Dynamic Curriculum List */}
        <div className="flex flex-col font-figtree lg:px-[60px] px-[20px] max-w-[1500px] w-full mx-auto">
          {/* Top section: Heading + box side by side */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 pt-[30px]">
            {/* Left: Heading + Curriculum */}
            <div className="lg:col-span-8 flex flex-col justify-start">
              {/* Heading */}
              <div className="font-[Figtree] font-bold text-4xl sm:text-5xl md:text-6xl lg:text-[64px] leading-snug sm:leading-tight md:leading-[110%] tracking-[-0.02em] sm:tracking-[-0.03em] md:tracking-[-0.04em] text-[#1D83F8] mb-10">
                Inside The Free Webinar
              </div>

              {/* Curriculum list */}
              <div className="flex flex-col gap-6">
                {webinar?.modules?.map((module, index) => (
                  <div
                    key={module?._id || index}
                    className="bg-gray-50 p-5 rounded-xl shadow-sm border border-gray-300"
                  >
                    <div
                      className="flex justify-between items-start cursor-pointer"
                      onClick={() => handleModuleToggle(index)}
                    >
                      {/* Left: Content */}
                      <div className="flex flex-col gap-4 w-full">
                        {/* Title */}
                        <div
                          className={`font-[Figtree] font-medium text-[25px] ${expandedModule === index ? "text-[#1D83F8]" : "text-[#1D2026]"
                            }`}
                        >
                          {module?.title || `Module ${index + 1}`}
                        </div>

                        {/* Stats in capsules */}
                        <div className="flex flex-wrap gap-3">
                          <span className="flex items-center gap-1 bg-gray-200 px-3 py-1 rounded-full text-[14px] text-[#4E5566]">
                            <MXIcon /> {Array.isArray(module?.lectures) ? module.lectures.length : 0} lectures
                          </span>
                          <span className="flex items-center gap-1 bg-gray-200 px-3 py-1 rounded-full text-[14px] text-[#4E5566]">
                            <ClockIcon /> {module?.totalModuleDuration || 0}h
                          </span>
                        </div>

                        {/* Description */}
                        <div
                          className={`font-[Figtree] font-normal text-[18px] leading-[130%] tracking-[-0.04em] text-[#1E1E1E] ${expandedModule === index ? "block" : "line-clamp-3"
                            }`}
                        >
                          {module?.description ||
                            "Detailed module description covering key concepts and learning objectives."}
                        </div>

                        {/* Lectures List - Only show when expanded */}
                        {expandedModule === index &&
                          Array.isArray(module?.lectures) &&
                          module.lectures.length > 0 && (
                            <div className="mt-4 flex flex-col gap-3">
                              {module.lectures.map((lecture, lectureIndex) => (
                                <div
                                  key={lecture?._id || lectureIndex}
                                  className="flex justify-between items-center py-2 border-b border-gray-200 last:border-b-0"
                                >
                                  <div className="flex items-center gap-3">
                                    <CurriculumPlayIcon />
                                    <span className="font-[Figtree] font-medium text-[14px] text-[#4E5566]">
                                      {lecture?.title || `Lecture ${lectureIndex + 1}`}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-1 text-[14px] font-medium text-[#4E5566]">
                                    <ClockIcon />
                                    {lecture?.totalLectureDuration || 0}m
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                      </div>

                      {/* Right: Big blue arrow */}
                      <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-50 cursor-pointer hover:bg-blue-100 transition ml-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={`w-7 h-7 text-[#1D83F8] transition-transform duration-200 ${expandedModule === index ? "rotate-180" : ""
                            }`}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                        </svg>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right: Info Box */}
            <div className="lg:col-span-4">
              <div className="sticky top-24 flex flex-col gap-5 bg-gray-50 p-6 rounded-xl shadow-sm">
                <div className="font-[Figtree] font-medium text-[20px] leading-[26px] text-[#818285]">
                  {webinar?.curriculumDescription ||
                    "Our carefully designed curriculum covers everything you need to master the subject, from basics to advanced topics, with practical examples and hands-on projects."}
                </div>

                <button
                  className="flex items-center gap-2 w-fit bg-blue-50 text-[#1D83F8] px-4 py-2 rounded-full hover:bg-blue-100 transition"
                  onClick={scrollToRegisterForm}
                >
                  <GetInTouch /> Register for Free Webinar?
                </button>

                <div className="flex flex-wrap gap-3">
                  <span className="flex items-center gap-1 bg-gray-200 px-3 py-1 rounded-full text-[14px] font-normal leading-[22px] text-[#4E5566]">
                    <FolderIcon /> {webinar?.modules?.length || 0} Sections
                  </span>
                  <span className="flex items-center gap-1 bg-gray-200 px-3 py-1 rounded-full text-[14px] font-normal leading-[22px] text-[#4E5566]">
                    <MXIcon />
                    {webinar?.modules?.reduce(
                      (acc, module) =>
                        acc +
                        (Array.isArray(module?.lectures) ? module.lectures.length : 0),
                      0
                    ) || 0}{" "}
                    Lectures
                  </span>
                  <span className="flex items-center gap-1 bg-gray-200 px-3 py-1 rounded-full text-[14px] font-normal leading-[22px] text-[#4E5566]">
                    <ClockIcon />
                    {webinar?.modules?.reduce(
                      (acc, module) => acc + (module?.totalModuleDuration || 0),
                      0
                    ) || 0}
                    h
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="px-[4.5%] max-w-[1500px] w-full mx-auto">
          <div
            className="
      relative flex flex-col items-center justify-center 
      p-5 w-full min-h-[80vh] sm:min-h-[90vh] md:min-h-[729px] 
      mb-8 rounded-[20px] overflow-hidden
      transition-all duration-500 ease-out hover:scale-[1.02] cursor-pointer
    "
            onClick={scrollToRegisterForm}
            style={{
              backgroundImage: `
        linear-gradient(to bottom, rgba(0,0,0,0) -15%, rgba(0,0,0,0.7) 5%, rgba(0,0,0,0.8) 67%),
        url(${webinar?.certificateBannerImage?.[0] || enrollCourseImage})
      `,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* Arrow */}
            <div
              className="absolute top-5 right-5 z-20"
              onClick={(e) => {
                e.stopPropagation();
                scrollToRegisterForm();
              }}
            >
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                <line x1="7" y1="17" x2="17" y2="7" />
                <polyline points="7 7 17 7 17 17" />
              </svg>
            </div>

            {/* Logo */}
            {webinar?.courseEntrollLogo ? (
              <img
                src={webinar.courseEntrollLogo}
                alt="logo"
                className="w-[220px] h-[100px] sm:w-[260px] sm:h-[120px] object-contain"
              />
            ) : (
              <KingsterLogo />
            )}

            {/* Text Block */}
            <div className="text-center text-white px-6 sm:px-10 mt-8 max-w-[700px]">
              {webinar?.webinarDescription || "Join our exclusive webinar to gain valuable insights from industry experts."}
            </div>

            {/* Date */}
            <div className="mt-6 text-lg sm:text-2xl font-semibold underline text-[white]">
              Free Webinar: {formatWebinarDateTime(webinar?.webinarDate, webinar?.webinarStartTime)}
            </div>

            {/* CTA Button */}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                scrollToRegisterForm();
              }}
              className="mt-10 flex items-center gap-2 px-6 py-3 font-bold bg-blue-500 
                 text-white rounded-full outline outline-2 outline-white text-base"
            >
              <img className="w-7 h-7 sm:w-10 sm:h-10" src="/assets/icons/enroll.svg" alt="" />
              Join Free Webinar
            </button>

            {/* Best Suited For */}
            <div className="mt-12 text-white/80 text-base sm:text-lg">Best suited for</div>

            <div className="flex flex-wrap justify-center gap-3 mt-3 px-3">
              {staticWebinarData.bestSuitFor?.map((item, index) => (
                <div
                  key={index}
                  className="px-4 py-2 text-sm sm:text-base font-medium text-gray-800 bg-white rounded-full border border-gray-700 whitespace-nowrap"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
          {/* Heading */}
          <div className="pb-4 sm:pb-6 md:pb-10 w-full pt-2 sm:pt-4 md:pt-5 font-[Figtree] font-bold text-3xl sm:text-4xl md:text-5xl lg:text-[64px] leading-snug sm:leading-tight md:leading-[110%] tracking-[-0.02em] sm:tracking-[-0.03em] md:tracking-[-0.04em] text-[#1D83F8]">
            Why Choose Us
          </div>

          <p className="mt-3 font-[Figtree] font-medium text-[20px] leading-[21px] text-[#818285] text-center max-w-2xl mx-auto">
            {webinar?.subtitle || "Expert-led webinars with practical insights and actionable strategies"}
          </p>

          {/* Grid of boxes */}
          <div className="mt-12 max-w-9xl mx-auto grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {msmSupportData.map(({ title, description, highlight }, index) => (
              <div
                key={index}
                className={`group rounded-2xl border border-[#1D83F8] p-6 text-left transition-colors duration-300
                  ${highlight
                    ? "bg-[#1D83F8] text-white border-none"
                    : "bg-white text-black hover:bg-[#1D83F8]"
                  }`}
              >
                {/* Title */}
                <h3 className="pt-6 font-figtree font-semibold text-[30px] leading-[1.1] tracking-[-0.04em] text-[#1E1E1E] transition-colors duration-300 group-hover:text-white mb-3">
                  {title}
                </h3>

                {/* Description */}
                <p className="font-[Figtree] font-normal text-[20px] leading-[1.5] tracking-[-0.04em] text-[#1E1E1E] transition-colors duration-300 group-hover:text-white">
                  {description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Follow Us Section */}
        <div className="px-16 py-8 my-8 text-white bg-blue-500 max-w-[1500px] w-full mx-auto">
          <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-[70%] pr-0 md:pr-8 border-b md:border-b-0 md:border-r border-gray-300 pb-8 md:pb-0">
              <div className="text-xl md:text-4xl font-semibold leading-tight md:leading-[67.2px] tracking-tighter">
                Follow us for upcoming webinars, new course launches, and
                exclusive offers. Got questions?
              </div>
              <button
                className="flex items-center gap-1 px-3 py-2 mt-5 text-sm font-semibold bg-gray-100 text-gray-800 rounded-full border border-gray-200 h-14 hover:bg-gray-200 transition-colors"
                onClick={scrollToRegisterForm} // Update this line
              >
                <GetInTouch /> Get in touch
              </button>
            </div>

            <div className="w-full md:w-[30%] pl-0 md:pl-5 pt-8 md:pt-0">
              <div className="text-sm font-normal leading-5 tracking-tighter">
                Stay connected with Kingster Education through our social media
                channels!
              </div>
              <div className="flex gap-3 mt-5">
                <div className="cursor-pointer hover:opacity-80 transition-opacity">
                  <CourseFacebook />
                </div>
                <div className="cursor-pointer hover:opacity-80 transition-opacity">
                  <CourseLinkedIn />
                </div>
                <div className="cursor-pointer hover:opacity-80 transition-opacity">
                  <CourseTwitter />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div
          ref={faqSectionRef}
          className="px-4 md:px-16 py-10 max-w-[1500px] w-full mx-auto"
        >
          <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-[40%] mb-8 md:mb-0">
              <div className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-semibold leading-snug sm:leading-tight md:leading-[70.4px] text-blue-500 tracking-tight sm:tracking-tighter md:tracking-tighter">
                Frequently Asked Questions
              </div>

              <div className="mt-3 text-sm md:text-base text-gray-800">
                Still you have any questions? Contact our Team via
                support@kingsteredu.com
              </div>
              <button
                className="hidden md:flex items-center gap-1 px-3 py-2 mt-5 text-sm font-semibold bg-gray-100 rounded-full border border-gray-200 hover:bg-gray-200 transition-colors"
                onClick={scrollToRegisterForm}
              >
                <GetInTouch /> Ask A Question
              </button>
            </div>

            <div className="w-full md:w-[60%] mt-3">
              <FaqList courseDetailsData={webinar?.faq} />
            </div>
          </div>

          <button
            className="flex md:hidden items-center gap-1 px-4 py-3 text-sm font-semibold bg-gray-100 rounded-full border border-gray-200 hover:bg-gray-200 transition-colors"
            onClick={scrollToRegisterForm}
          >
            <GetInTouch /> Ask A Question
          </button>
        </div>
      </div>
      <FooterComponent />
    </div>
  );
};

export default WebinarDetailsPage;